import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Simple module-level cache — settings rarely change and this hook is called
// from multiple pages. Refreshes at most once per app load.
let cached = null;
let inflight = null;

const loadPublicUrl = async () => {
  if (cached !== null) return cached;
  if (!inflight) {
    inflight = api
      .get("/settings")
      .then((r) => {
        cached = (r.data && r.data.public_url) || "";
        return cached;
      })
      .catch(() => {
        cached = "";
        return cached;
      });
  }
  return inflight;
};

/**
 * Returns the effective base URL for share links.
 * - If the admin has configured `public_url` in Settings, use it.
 * - Otherwise fall back to the current window origin.
 */
export function useShareBaseUrl() {
  const [base, setBase] = useState(
    cached !== null && cached
      ? cached
      : (typeof window !== "undefined" ? window.location.origin : ""),
  );
  useEffect(() => {
    let mounted = true;
    loadPublicUrl().then((pu) => {
      if (!mounted) return;
      if (pu) setBase(pu);
      else if (typeof window !== "undefined") setBase(window.location.origin);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return base;
}

/** Build a full share URL for a given path (e.g. "/p/some-slug"). */
export function buildShareUrl(base, path) {
  const safeBase = (base || "").replace(/\/+$/, "");
  const safePath = path?.startsWith("/") ? path : `/${path || ""}`;
  return `${safeBase}${safePath}`;
}
